import { gql } from "@apollo/client";

const GET_CLIENTS_WITH_UPLOAD_UNITS = gql`
  query clientsWithUploadUnits(
    $missingClientIdentifier: Boolean
    $uploadUnitStatuses: [InvoiceUploadUnitStatus]
    $clientIdentifier: String
    $sortDirection: SortDirection
    $skip: Int
    $take: Int
    $sortBy: UploadUnitClientAggregationSortBy
  ) {
    clientsWithUploadUnits(
      missingClientIdentifier: $missingClientIdentifier
      uploadUnitStatuses: $uploadUnitStatuses
      clientIdentifier: $clientIdentifier
      sortDirection: $sortDirection
      sortBy: $sortBy
      skip: $skip
      take: $take
    ) {
      totalCount
      items {
        id
        filteredTotalCount
        client {
          id
          name
          emailConnections {
            id
            clientIdentifier
            emailAddress
            modifiedAt
          }
          invoiceReaderTemplates {
            id
            name
            state
          }
          settings {
            product {
              defaultInvoiceServiceType
            }
          }
        }
        statusCounts {
          count
          status
        }
      }
    }
  }
`;

export default GET_CLIENTS_WITH_UPLOAD_UNITS;
